/**
* Lightweight A–Z filter
* - No frameworks
* - O(1) attribute change per click (fast even with 5–10k items)
* - Works with either server-provided data-initials or auto-computed from data-artist-name
*/
(function () {
  const grid = document.getElementById('artistGrid');
  const az = document.getElementById('az');


  // Utility: normalize unicode + strip diacritics, then lower-case
  const toAsciiLower = (str) =>
  str
  .normalize('NFD')
  .replace(/\p{Diacritic}/gu, '')
  .toLowerCase();


  // Extract first two token initials (first + second names) from a display name
  function initialsFromName(name) {
    const tokens = toAsciiLower(name)
    .replace(/[^a-z\s'-]/g, '') // strip non-letters
    .trim()
    .split(/\s+/)
    .filter(Boolean);


    // Guard: if no tokens, return empty
    if (!tokens.length) return [];


    const first = tokens[0]?.[0];
    // Find the next non-prefix token for the "second name"
    const prefixes = new Set(['de','del','della','der','van','von','la','le','du','da','di','dos','das','the']);
    let second = null;
    for (let i = 1; i < tokens.length; i++) {
      const t = tokens[i].replace(/^[\-']+/, '');
      if (!prefixes.has(t)) { second = t[0]; break; }
    }
    return [first, second].filter(Boolean);
  }


  // Initialize cards: compute data-initials if missing, and set simple content for demo
  const cards = Array.from(grid.querySelectorAll('.artist-list--card'));
  for (const card of cards) {
    const name = card.getAttribute('data-artist-name') || card.textContent || '';
    const inits = initialsFromName(name);
    if (inits.length) card.setAttribute('data-initials', inits.join(' '));
    if (!card.innerHTML.trim()) card.innerHTML = `<strong>${name}</strong>`;
  }

  // Hide letters that have no matches
  const available = new Set(cards.flatMap(card => card.getAttribute('data-initials').split('')));
  az.querySelectorAll('button[data-letter]').forEach(btn => {
    const l = btn.getAttribute('data-letter').toLowerCase();
    if (l !== 'all' && !available.has(l)) btn.hidden = true;
  });

  // After hiding unused letters:
  const visibleButtons = Array.from(az.querySelectorAll('button:not([hidden])')).length;
  az.style.setProperty('--az-columns', visibleButtons);
  // Calculate an ideal column count (around 6–8 per row on mobile)
  const perRow = Math.ceil(visibleButtons / Math.ceil(visibleButtons / 7));
  az.style.setProperty('--az-columns-mobile', perRow);


  // Click handling via delegation
  az.addEventListener('click', (e) => {
    const btn = e.target.closest('button[data-letter]');
    if (!btn) return;
    const letter = btn.getAttribute('data-letter').toLowerCase();


    // Update pressed states
    az.querySelectorAll('button[aria-pressed]').forEach(b => b.setAttribute('aria-pressed', 'false'));
    btn.setAttribute('aria-pressed', 'true');


    // Single attribute flip on the grid triggers all filtering via CSS
    grid.setAttribute('data-filter', letter);
    if (location.hash !== `#${letter}`) {
      window.location.hash = letter;
    }
  });


  // Optional: deep-linking via hash (#A, #B, etc.)
  const applyHash = () => {
    const h = (location.hash || '').replace('#', '').toLowerCase();
    if (h && h.length === 1 && h >= 'a' && h <= 'z') {
      const btn = az.querySelector(`[data-letter="${h.toUpperCase()}"]`);
      if (btn) btn.click();
    } else {
      az.querySelector('[data-letter="all"]').click();
    }
  };

  window.addEventListener('hashchange', applyHash);
  applyHash();
})();